import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';

import ProvaService from '../../services/Prova';
import CandidatoService from '../../services/Candidato';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';
import Text from '../../components/Inputs/Text/Text';
import Toast from "../../components/Toast/Toast";
import Arquivo from '../../components/Inputs/File/File';

import Regiao from '../../forms/Endereco/Regiao';

import ButtonsForm from '../../forms/Buttons/ButtonsForm';

import { 
    isBlank, 
    isBlankHelperText, 
} from '../../helper/ValidationHelper';
import { filterPersistence } from '../../helper/ParseStateHelper';
import { numberMask } from '../../helper/MaskHelper';

import { Layout } from '../../layouts/private/Private';

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prova: {
                codigo: '',
                nome: '',
                cpf: '',
            },
            errors: {
                codigo: false,
                nome: false,
                cpf: false,
            },
            helpers: {
                codigo: null,
                nome: null,
                cpf: null,
            },
            candidatoEncontradoComId: false,
            candidatoEncontradoComCodigo: false,
            loadingButtonSave: false,
            loading: true,
            history: {
                path: null,
                state: null,
            },
        };
    }

    // INPUTS
    handleChange = e => {
        this.setState({
            ...this.state, 
            prova: {
                ...this.state.prova,
                [e.target.name]: e.target.name === 'cpf' ? numberMask(e.target.value) : e.target.value, 
            },
            errors: {...this.state.errors, [e.target.name]: false },
            helpers: {...this.state.helpers, [e.target.name]: null }
        });
    };

    setToast = t => this.Toast = t;
    setRegiao = r => this.Regiao = r;
    setArquivo = a => this.Arquivo = a;

    isValid = () => {
        if ( isBlank(this.state.prova.nome) || isBlank(this.state.prova.cpf) || isBlank(this.state.prova.codigo) ) {
            this.setState({ 
                errors: {
                    codigo: isBlank(this.state.prova.codigo) ? true : false,
                    nome: isBlank(this.state.prova.nome) ? true : false,
                    cpf: isBlank(this.state.prova.cpf) ? true : false,
                },
                helpers: {
                    codigo: isBlank(this.state.prova.codigo) ? isBlankHelperText() : null,                    
                    nome: isBlank(this.state.prova.nome) ? isBlankHelperText() : null,
                    cpf: isBlank(this.state.prova.cpf) ? isBlankHelperText() : null,
                },
            })
            return false
        }
        return true
    }

    handleSubmit = () => {
        const formIsValid = this.isValid();
        const formRegiaoIsValid = this.Regiao.isValid();
        const formArquivoIsValid = this.Arquivo.isValid();

        if (!formIsValid || !formRegiaoIsValid || !formArquivoIsValid) {
            this.setState({ loadingButtonSave: false });
            return
        }

        const config = { headers: { 'content-type': 'multipart/form-data' } }

        const prova = new FormData();
        prova.append('codigo', this.state.prova.codigo)
        prova.append('nome', this.state.prova.nome)
        prova.append('cpf', this.state.prova.cpf)
        prova.append('regiao', this.Regiao.state.region)
        prova.append('cartao', this.Arquivo.state.file) 
        
        ProvaService.addComCartao(prova, config)
            .then(res => {
                this.Toast.setState({
                    message: {
                        message: "Prova Adicionada com Sucesso.",
                        type: "success",
                        open: true
                    }
                });

                setTimeout(() => this.handleBack(), 1000);
            })
            .catch(error => {
                const errors = error.response.data.mensagens !== undefined && error.response.data.mensagens.length > 0 ? `${error.response.data.mensagens.map(mensagen => mensagen).join(" ")}` : "";
                
                this.Toast.setState({
                    message: {
                    message: `Ocorreu um Problema ao Adicionar a Prova. ${errors}`,
                    type: "error",
                    open: true
                    }
                })
                this.setState({ loadingButtonSave: false });
            })
    }

    buscarCandidatoPorCodigo = (codigo) => {
        if (codigo.length !== 16)
            return

        const filter = [{ field: 'codigoProva', value: codigo }];

        CandidatoService.filters(filter)
            .then(res => {
                if (res.data.content.length === 0)
                    return

                const candidato = res.data.content[0];
                
                this.setState({
                    prova: {
                        codigo: candidato.codigoProva ?? "",
                        nome: candidato.nomeExibicao,
                        cpf: candidato.cpf,
                    },
                    candidatoEncontradoComCodigo: true,
                });
                
                this.Regiao.setState({ 
                    region: candidato.localProva.endereco.municipio.regiao.id,
                    disabled: {
                        region: true,
                    },
                });                
            });
    }

    buscarCandidatoPorId = (id) => {
        if (id.length === 0)
            return

        CandidatoService.find(id)
            .then(res => {
                const candidato = res.data;
                
                this.setState({
                    prova: {
                        codigo: candidato.codigoProva ?? "",
                        nome: candidato.nomeExibicao,
                        cpf: candidato.cpf,
                    },
                    candidatoEncontradoComId: true,
                });
                
                this.Regiao.setState({ 
                    region: candidato.localProvaFinal.regiao.id,
                    disabled: {
                        region: false,
                    },
                });                
            });
    }

    componentDidMount() {
        this.setState({ loading: true, history: filterPersistence(this.props.location) });

        const id = this.props.match.params.id;
        if (id)
            this.buscarCandidatoPorId(id);
    }

    handleBack = () => {
        this.props.history.push({
            pathname: this.state.history.path ? `${this.state.history.path}` : `/admin/provas`,
            state: {
                history: {
                    state: this.state.history.state
                }
            }
        });
    }

    render () {
        const page = 'Adicionar Prova';
        const links = [
            {
                path: null,
                name: 'Logística Reversa'
            },
            {
                path: { 
                    pathname: this.state.history.path ? `${this.state.history.path}` : `/admin/provas`,
                    state: {
                        history: {
                            state: this.state.history.state
                        }
                    }
                },
                name: 'Listagem de Provas'
            }
        ];

        return (
            <Layout>
                <Toast parentRef={this.setToast} />
                <Grid container >
                    <Grid item xs={12}>
                        <Breadcrumbs links={links} active={page} />
                    </Grid>
                </Grid>

                <Title>{page}</Title>

                <Grid container spacing={3} alignItems='center'>
                    <Grid item sm={12} lg={3}>
                        <Text
                            required
                            maxLength='16'
                            name="codigo"
                            label="Código da Prova"
                            value={this.state.prova.codigo}
                            error={this.state.errors.codigo}
                            onChange={(e) => {
                                this.handleChange(e);
                                this.buscarCandidatoPorCodigo(e.target.value);
                            }}
                            helperText={this.state.helpers.codigo}
                        />
                    </Grid>
                </Grid>
                
                <Grid container spacing={3} alignItems='center'>
                    <Grid item sm={12} lg={2}>
                        <Regiao parentRef={this.setRegiao} />
                    </Grid>

                    <Grid item sm={12} lg={5}>
                        <Text
                            required
                            name="nome"
                            label="Nome na Prova"
                            value={this.state.prova.nome}
                            error={this.state.errors.nome}
                            onChange={this.handleChange}
                            helperText={this.state.helpers.nome}
                            disabled={this.state.candidatoEncontradoComCodigo || this.state.candidatoEncontradoComId}
                        />
                    </Grid>

                    <Grid item sm={12} lg={3}>
                        <Text
                            required
                            maxLength='14'
                            name="cpf"
                            label="CPF na Prova"
                            value={this.state.prova.cpf}
                            error={this.state.errors.cpf}
                            onChange={this.handleChange}
                            helperText={this.state.helpers.cpf}
                            disabled={this.state.candidatoEncontradoComCodigo || this.state.candidatoEncontradoComId}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={3} alignItems='center'>
                    <Grid item sm={12} xl={12} >
                        <Typography variant="body1">Cartão-Resposta:</Typography>
                        <br />

                        <Typography variant="body2">
                            - O Cartão deve ser anexado no formato <b>.jpg</b>.<br />
                            - O Cartão precisa ser digitalizado em formato adequado para que possa ser processado corretamente nas etapas de corte e leitura de marcações.<br />
                        </Typography>                            
                    </Grid>

                    <Grid item lg={12} sm={12} >
                        <Arquivo parentRef={this.setArquivo} accept=".jpg" />
                    </Grid>
                </Grid>

                <Grid container spacing={3} alignItems='center'>
                    <ButtonsForm 
                        onClick={this.handleSubmit} 
                        onBack={this.state.history.path ? () => this.handleBack() : null} 
                        loading={this.state.loadingButtonSave} 
                    />
                </Grid>
            </Layout>
        )
    }
}

export default withRouter(Form);